<template>
  <div></div>
</template>

<script>
import _ from 'underscore'
import axios from 'axios'
import serviceRegistery from '../../mixins/serviceRegistery'
import { custToolHelper } from '../../mixins/custToolHelper'
import { helpers } from '../../mixins/helpers'
export default {
  created: function() {
    this.loadResources()
    this.$store.state.paramStore.showSearchField = false
    this.$store.state.cssStore.showSearchField = false
    this.$store.state.localeStore.showSearchField = false
  },
  mixins: [custToolHelper, serviceRegistery, helpers],
  methods: {
    loadResources() {
      let that = this
      let p1 = new Promise(function(resolve) {
        axios
          .get(
            that.$hostnameStatic +
              'static/assets/data/default_params_subbrand.json'
          )
          .then(response => {
            that.$store.state.paramStore.params = response.data
            that.$store.state.paramStore.loadedParams = JSON.parse(
              JSON.stringify(that.$store.state.paramStore.params)
            )
            console.log('Param Data--->', that.$store.state.paramStore.params)
            resolve(response.data)
          })
      })

      let p2 = new Promise(function(resolve) {
        axios
          .get(
            that.$hostnameStatic +
              'static/assets/data/default_strings_subbrand.json'
          )
          .then(response => {
            that.$store.state.localeStore.strings = response.data
            that.$store.state.localeStore.loadedStrings = JSON.parse(
              JSON.stringify(that.$store.state.localeStore.strings)
            )
            console.log(
              'String Data--->',
              that.$store.state.localeStore.strings
            )
            resolve(response.data)
          })
      })

      let p3 = new Promise(function(resolve) {
        axios
          .get(
            that.$hostnameStatic +
              'static/assets/data/default_css_data_subbrand.json'
          )
          .then(response => {
            that.$store.state.cssStore.css = response.data
            that.$store.state.cssStore.loadedCss = JSON.parse(
              JSON.stringify(that.$store.state.cssStore.css)
            )
            console.log('CSS Data --->', that.$store.state.cssStore.loadedCss)
            resolve(response.data)
          })
      })

      Promise.all([p1, p2, p3]).then(values => {
        this.loadApp()
      })
    },
    loadApp() {
      // Set Sub-brand info
      // TO-DO needs to get all the information form sub-brand store.
      // Get Co-branded data
      this.getCobrandedData()
      this.searchSites()
    },
    getCobrandedData() {
      let self = this
      //Get Label Draft Data if avaliable.
      let _id = this.$store.state.appStore.selectedSubbrandInfo._id
      let reqObj = {
        id: _id,
        includeBrand: true,
        includeConfig: true
      }
      let p1 = new Promise(function(resolve) {
        serviceRegistery
          .makeCall({
            url: self.$hostname + 'services/subbrand/get',
            method: 'POST',
            data: reqObj
          })
          .then(
            response => {
              if (response && response.data) {
                self.$store.state.appStore.selectedSubbrandInfo = response.data
              }
              if (response.data && response.data.brand) {
                self.$store.state.custAppStore.cobrandDraftData =
                  response.data.brand
                console.log(
                  'Draft Data---->',
                  self.$store.state.custAppStore.cobrandDraftData
                )
              } else {
                // Draft version is not available. Start from the scratch mode
                self.$store.state.custAppStore.cobrandDraftData = {}
                console.log('Draft Data not avaliable')
              }
              if (
                response.data &&
                response.data.config &&
                response.data.config.appConfig
              ) {
                self.$store.state.appStore.optedApps =
                  response.data.config.appConfig
              }
              resolve(response)
            },
            error => {
              console.log('Error', error.response.data)
            }
          )
          .catch(error => {
            this.showToastMessage(
              'Sorry, a technical error has occurred! Please try again later.'
            )
          })
      })

      Promise.all([p1]).then(values => {
        let cobrandDraftData = this.$store.state.custAppStore.cobrandDraftData
        if (!_.isEmpty(cobrandDraftData)) {
          this.parseLabelDraftData(
            this.$store.state.custAppStore.cobrandDraftData
          )
        } else {
          var self = this
          setTimeout(function() {
            self.$store.state.custAppStore.dataChanged = false
          }, 1000)
          this.$router.push('/customization/custTabs')
        }
      })
    },
    searchSites(query) {
      let self = this
      serviceRegistery
        .makeCall({
          url: self.$hostname + 'services/brand/sites',
          method: 'POST'
        })
        .then(
          response => {
            console.log(response)
            self.$store.state.paramStore.popularSites = response.data.provider
          },
          error => {
            console.log('Error', error)
          }
        )
        .catch(error => {
          this.showToastMessage(
            'Sorry, a technical error has occurred! Please try again later.'
          )
        })
    },
    parseLabelDraftData(data) {
      // Param data Merge
      var tempParams = JSON.parse(
        JSON.stringify(this.$store.state.paramStore.params)
      )

      if (!_.isEmpty(data.param)) {
        this.generateVueJsonParam(tempParams, data.param)
      }

      this.$store.state.paramStore.dbParams = JSON.parse(
        JSON.stringify(tempParams)
      )

      this.$store.state.paramStore.loadedParams = tempParams

      // CSS data Merge
      var tempCss = JSON.parse(JSON.stringify(this.$store.state.cssStore.css))

      if (!_.isEmpty(data.cbdk)) {
        this.generateVueJsonCss(tempCss, data.cbdk)
      }

      this.$store.state.cssStore.dbCss = JSON.parse(JSON.stringify(tempCss))

      this.$store.state.cssStore.loadedCss = tempCss

      // String data Merge
      var tempStrings = JSON.parse(
        JSON.stringify(this.$store.state.localeStore.strings)
      )

      if (!_.isEmpty(data.locale)) {
        this.generateVueJsonLocale(tempStrings, data.locale)
      }

      this.$store.state.localeStore.dbStrings = JSON.parse(
        JSON.stringify(tempStrings)
      )
      this.$store.state.localeStore.loadedStrings = tempStrings

      // Mearge Font List with Param Data
      // let cobrandDraftData = this.$store.state.custAppStore.cobrandDraftData
      // let brandsFontData = []
      // if (cobrandDraftData.font && cobrandDraftData.font.default) {
      //   brandsFontData = cobrandDraftData.font.default
      // }

      // this.$store.state.cssStore.fontOptions = brandsFontData

      // let loadedCss = this.$store.state.cssStore.loadedCss
      // let fontFamilyObj = _.findWhere(loadedCss[0].form, {
      //   ref_key: 'global_font_family'
      // })

      // for (let count = 0; count < brandsFontData.length; count++) {
      //   fontFamilyObj.options.unshift(brandsFontData[count])
      // }

      var self = this
      setTimeout(function() {
        self.$store.state.custAppStore.dataChanged = false
      }, 1000)

      this.$router.push('/customization/custTabs')
    }
  }
}
</script>
